module.exports = __webpack_public_path__ + "d237031968ca411b0e001226d7a75ec3.svg";